import { Box, Container, Grid, Stack } from "@mui/material";
import { PackageCard } from "./PackageCard";
import { useEffect } from "react";
import { useEventPackages } from "./useEventPackages";
import { DynamicSkeleton } from "@/shared/base/components/DynamicSkeleton/DynamicSkeleton";
import { useCssMediaQuery } from "@/shared/base/hooks/useCssMediaQuery";
import { EmptyState } from "@/shared/base/components/EmptyState/EmptyState";
import { BrandedCallout } from "../../BrandedCallout/BrandedCallout";
import { BuildYourOwnPackageCard } from "./BuildYourOwnPackageCard";
import { useAppSystem } from "@/global/hooks/useAppSystem";
import { StaticBuildYourOwn } from "./StaticBuildYourOwn";
import { useCartHelpers } from "../useCartHelpers";
import { useAppStore } from "@/global/store";
import { selectUser } from "@/global/store/data/user";

export function EventPakcages() {
  const { apis, states, handlers } = useEventPackages();
  const { teamConfig } = useAppSystem();
  const {
    uiConfigs,
    packageConfigs: { staticBuildYourOwn },
  } = teamConfig;
  const { resetCartSelections } = useCartHelpers();
  const user = useAppStore(selectUser);

  useEffect(() => {
    handlers.handleGetPackages();
  }, [user]);

  useEffect(() => {
    resetCartSelections();
  }, []);

  return (
    <Box mb={8}>
      <Container maxWidth="xl">
        <Box>
          <BrandedCallout title={uiConfigs?.bannerImage?.title} />
        </Box>

        <Box mt={6}>
          {apis.getPackages.isLoading ? <PackagesSkeletons /> : null}
          {!apis.getPackages.isLoading && states.packages.length === 0 ? (
            <PackagesEmptyState />
          ) : null}

          {staticBuildYourOwn &&
          staticBuildYourOwn?.displayBuildYourOwnOnTop ? (
            <Box mb={6}>
              <StaticBuildYourOwn
                title={staticBuildYourOwn?.title}
                description={staticBuildYourOwn?.description}
                minEventSelectionCount={
                  staticBuildYourOwn?.minEventSelectionCount
                }
                onSelect={handlers.handleSelectPackage}
              />
            </Box>
          ) : null}

          {!apis.getPackages.isLoading && states.packages.length > 0 ? (
            <Grid container spacing={5} justifyContent={"center"}>
              {states.packages.map((pkg, idx) => {
                if (pkg.isBuildYourOwn) {
                  return (
                    <Grid key={pkg.id} item xs={12} md={6} lg={4}>
                      <BuildYourOwnPackageCard
                        title={pkg.title}
                        description={pkg.description}
                        events={pkg.events}
                        onClick={() => handlers.handleSelectPackage(pkg)}
                      />
                    </Grid>
                  );
                }
                return (
                  <Grid
                    key={pkg.id}
                    item
                    xs={12}
                    md={states.packages.length === 1 ? 12 : 6}
                    lg={states.packages.length === 1 ? 12 : 4}
                  >
                    <PackageCard
                      title={pkg.title}
                      description={pkg.description}
                      events={pkg.events as any}
                      isSelected={pkg.id === states.selectedPackage?.id}
                      onClick={() => handlers.handleSelectPackage(pkg)}
                      onlyOnePackageAvailable={states.packages.length === 1}
                      isLoading={states?.isLoading}
                    />
                  </Grid>
                );
              })}
            </Grid>
          ) : null}
        </Box>

        {staticBuildYourOwn && !staticBuildYourOwn?.displayBuildYourOwnOnTop ? (
          <Box mt={6}>
            <StaticBuildYourOwn
              title={staticBuildYourOwn?.title}
              description={staticBuildYourOwn?.description}
              minEventSelectionCount={
                staticBuildYourOwn?.minEventSelectionCount
              }
              onSelect={handlers.handleSelectPackage}
            />
          </Box>
        ) : null}
      </Container>
    </Box>
  );
}

function PackagesSkeletons() {
  const { sm: smDown, md: mdDown } = useCssMediaQuery("down");

  return (
    <Box>
      <Grid container spacing={4}>
        {Array.from({ length: smDown ? 2 : mdDown ? 4 : 8 })
          .fill(1)
          .map((itm, idx) => {
            return (
              <Grid key={idx} item xs={12} sm={6} md={4} lg={3}>
                <DynamicSkeleton
                  rowCount={4}
                  spacing={2}
                  widths={["100%", "100%", "80%", "60%"]}
                  heights={["120px", "20px", "20px", "20px"]}
                />
              </Grid>
            );
          })}
      </Grid>
    </Box>
  );
}

function PackagesEmptyState() {
  return (
    <Stack alignItems={"center"} justifyContent={"center"} height={"340px"}>
      <EmptyState
        title={"No packages available"}
        description={"Try refreshing your browser."}
      />
    </Stack>
  );
}
